import EmblaCarousel from 'embla-carousel';

const relatedContent = document.querySelector('.news__related-content');
const emblaNode = document.querySelector('.news__related-content .embla');

// @todo make reusable
const updateNavigation = (embla, prevButton, nextButton) => {
  // hide the arrows if there's not enough slides to slide
  const canPrev = embla.canScrollPrev();
  const canNext = embla.canScrollNext();

  if (!canPrev && !canNext) {
    prevButton.classList.add('embla__button--hide');
    nextButton.classList.add('embla__button--hide');
  } else {
    if (canPrev) {
      prevButton.removeAttribute('disabled');
    } else {
      prevButton.setAttribute('disabled', 'disabled');
    }

    if (canNext) {
      nextButton.removeAttribute('disabled');
    } else {
      nextButton.setAttribute('disabled', 'disabled');
    }
  }
};

const init = () => {
  // Create carousel.
  const embla = EmblaCarousel(emblaNode, {
    align: 'start',
  });

  // Attach event listeners to arrow buttons.
  const prevButton = relatedContent.querySelector('.embla__button--prev');
  const nextButton = relatedContent.querySelector('.embla__button--next');

  prevButton.addEventListener('click', embla.scrollPrev, false);
  nextButton.addEventListener('click', embla.scrollNext, false);

  // Update arrow buttons disabled state on slider init/slide select.
  embla.on('init', () => updateNavigation(embla, prevButton, nextButton));
  embla.on('select', () => updateNavigation(embla, prevButton, nextButton));
};

(() => {
  if (relatedContent && emblaNode) {
    init();
  }
})();
